import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationComponent } from './pagination.component';
import { LuIconModule } from 'lu-icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [PaginationComponent],
	exports: [PaginationComponent],
	imports: [CommonModule, LuIconModule, TranslateModule]
})
export class PaginationModule {}
